export default __webpack_public_path__ + "static/media/medicare.ecf5af92.svg";